export default function OddsCalc () {

	if(!document.getElementById('oddsCalc')) return;

	let drawsWrapper = document.getElementById("oddsCalc-drawsWrapper"),
	draws = [].slice.call( drawsWrapper.querySelectorAll('.oddsCalc-draw') ),
	addDrawBtn = document.getElementById("oddsCalc-addDraw"),
	//calcBtn = document.getElementById("oddsCalc-calculateOdds"),
 // repeatNumbersCheckbox = document.getElementById("oddsCalc-repeatNumbers"),
	repeatNumbersCheckbox =  document.querySelector('.oddsCalc-draw-repeatNumbers'),
	repeatNumbers = false,
	ticketsNumber = document.getElementById('oddsCalc-ticketsNumber'),
	selectPreset =  document.querySelector('.oddsCalc-selectPreset'),
	showOdds =  document.querySelector('.show_odds'),
	//repeatNumberWarning =  document.querySelector('.oddsCalc-info'),
	//repeatNumberWarningInfoText = repeatNumberWarning.querySelector('.oddsCalc-info-text'),
	//repeatNumberWarningIsShown = false,
	//numberSetsWrapper = document.querySelector('.oddsCalc-ticket'),
	finalChancesNode = document.querySelector('.oddsCalc-chancesPanel-chances'),
	resultsNode = document.getElementById("oddsCalc-results");

	draws.forEach((draw, i) => {

		addInputsListeners(draw, i);

	});

	showOdds.onclick = ()=>{
		let viewportOffset = showOdds.getBoundingClientRect();
		console.log(showOdds.offsetTop);
		window.scrollTo({
		    top: viewportOffset.top - document.getElementById('masthead').clientHeight - 30,
		    behavior: "smooth"
		});
	}
	repeatNumbersCheckbox.onchange = ()=>{

	
		/*if(!repeatNumberWarningIsShown){
			repeatNumberWarningInfoText.classList.add('oddsCalc-info-text_visible');
			repeatNumberWarningIsShown = true;

			repeatNumberWarning.onclick = (e)=> {
				e.stopPropagation();
				e.preventDefault();
				repeatNumberWarningInfoText.classList.toggle('oddsCalc-info-text_visible');
			}
		}*/

		repeatNumbers = repeatNumbersCheckbox.checked;
		calcChances();
	}

	selectPreset.onchange = ()=>{

	 let preset = PRESETS_JSON[selectPreset.value],
	 preset_draws =  preset.draws,
	 lotteryName = preset.lottery_name,
	 affilateLink = preset.link,
	 ctaButton = document.querySelector('.oddsCalc-cta');
	 drawsWrapper.innerHTML='';

	 ctaButton.href=affilateLink;

	 ctaButton.innerHTML = lotteryName?`Visit ${lotteryName} Lottery`: 'Play Lottery Online';

	 repeatNumbers = repeatNumbersCheckbox.checked = preset.repeat=="false"?false:true;

	 draws = [];

	 preset_draws.forEach(( draw, n )=>{

	 	let drawNode = document.createElement('div');

	 	drawNode.className = 'oddsCalc-draw';
	 	
	 	drawNode.innerHTML = `
			<div class="oddsCalc-draw-title">${draw.name}</div>
			<div class="oddsCalc-draw-remove">X</div>
			<div class="oddsCalc-draw-numberpickers">
				<div class="oddsCalc-draw-rangeTitle"># of Balls</div>
				<label class="oddsCalc-draw-numbericker">
					<input type="number" value="${draw.winning}" min="1" class="winningBalls">
				</label>
				<div class="oddsCalc-draw-rangeTitle">Range</div>
				<div class="oddsCalc-draw-range">
					<label class="oddsCalc-draw-numbericker">
						<input type="number" value="${draw.minBall}" min="0" class="minBall">
						
					</label>
					<div class="oddsCalc-draw-rangeTitle">to</div>
					<label class="oddsCalc-draw-numbericker">
						<input type="number" value="${draw.maxBall}" min="1" class="maxBall">
						
					</label>
				</div>
				<input type="hidden" value="${draw.maxBall-draw.minBall+1}" min="1" class="ballsTotal">				
			</div>
		`;

		draws.push(drawNode);
		drawsWrapper.appendChild(drawNode);
		addInputsListeners (drawNode, n);


	 });
	 calcChances();


	}

	function addInputsListeners ( draw, setID ) {

		let totalBallsInput =  draw.querySelector('.ballsTotal'),
				minBallInput=draw.querySelector('.minBall'),
				maxBallInput=draw.querySelector('.maxBall'),
				winingBallsInput = draw.querySelector('.winningBalls'),
				removeBtn = draw.querySelector('.oddsCalc-draw-remove');

		draw.range = Number(totalBallsInput.value);
		draw.winning = Number(winingBallsInput.value);
		draw.setID = setID;

		removeBtn.onclick = ()=> {

			draw.parentNode.removeChild(draw);
			draws.forEach((_draw,i)=>{
				if (_draw==draw) {
					draws.splice(i, 1);
					
				}
			});
			setDrawsTitles ();
			calcChances();

		}


		minBallInput.onchange = ()=>{

			let minBall = Number(minBallInput.value),
				maxBall = Number(maxBallInput.value);

			if(minBall >= maxBall) {
				maxBall = minBall+1;
				maxBallInput.value = maxBall;

			}

			draw.range = maxBall - minBall + 1;
			
			//changeDrawNumbersetContent (draw)
			calcChances();
		}

		maxBallInput.onchange = ()=>{

			let minBall = Number(minBallInput.value),
				maxBall = Number(maxBallInput.value);

			if(maxBall <= minBall) {
				minBall = maxBall-1;
				minBallInput.value = minBall;

			}

			draw.range = maxBall - minBall + 1;
			
			//changeDrawNumbersetContent (draw)
			calcChances();
		}

		winingBallsInput.onchange = ()=>{
			draw.winning = Number(winingBallsInput.value);

			//changeDrawNumbersetContent (draw);
			calcChances();
		}
	}

	function changeDrawNumbersetContent (draw) {
		
		let numbersetNode = document.getElementById('oddsCalc-ticket-numbersSet_'+draw.setID),
		ballSpans='';

		numbersetNode.querySelector('.oddsCalc-ticket-total').innerHTML =
			 `<div class="oddsCalc-ticket-total">
			<strong>${draw.winning}</strong> from <strong>${draw.range}</strong> 
			</div>`;

			for (var i = 0; i <  draw.winning; i++) {
				ballSpans += '<span></span>';
			}
			numbersetNode.querySelector('.oddsCalc-ticket-balls').innerHTML =ballSpans;
	}

	addDrawBtn.addEventListener('click',() => {



		let setId = Math.random().toString(36).substr(2, 9),
		numberSetHTML='',
		drawTitle = '',
		newDraw = draws[draws.length - 1].cloneNode(true);


		addInputsListeners( newDraw, setId );
		draws.push( newDraw );
		drawsWrapper.appendChild( newDraw );


		setDrawsTitles ();
		calcChances();

	} );

	ticketsNumber.addEventListener('change', calcChances);

	function setDrawsTitles () {

		let drawSet= [].slice.call(drawsWrapper.querySelectorAll('.oddsCalc-draw-title'));

		drawSet.forEach((draw, n)=>{
			let title = ordinal_suffix(n+1)+' Set of Balls';
			draw.innerHTML = title;

		});

	}
 
	function calcChances() {
		let mathCalcSteps,
		drawsResults = [],
		allSetsChansesStr = '',
		ticketsN  =  Number(ticketsNumber.value),
		finalResult,
		chancesAllDraws = 1;
		
		mathCalcSteps = '<table class="oddsCalc-calcSteps">';

		draws.forEach((draw) => {
			let  range = draw.range,
				chance = 0,
				setResult,
				setResultTxt = '',
				factorialDescribe ='',
				bNumFact = factorial(draw.winning),
				chanceStr='',

				chancesResult = 1;

			mathCalcSteps += '';

			for (let i = 0; i < draw.winning; i++) {
				chance = range + (repeatNumbers ? 0: -i);
				chanceStr += (i > 0 ? ' * ':'') + '1/' + chance;
				chancesResult*= chance;
				mathCalcSteps +=`<tr>
					<td class="oddsCalc-calcSteps-desc">Your ${ ordinal_suffix(i+1) } number has a 1 in ${chance} ${ (!repeatNumbers && i) > 0 ? '('+range+'-'+i+')':''} chance of being correct.</td>
					<td class="oddsCalc-calcSteps-calc">${chanceStr} = 1/${chancesResult}</td>
					</tr>`;
			}

			for(let i=1; i <= draw.winning; i++) {
				factorialDescribe += i+'*';
			}
			factorialDescribe = factorialDescribe.slice(0, -1);


			////////////////FINAL RESULT FOR SET/////////////////////////

			setResult = (chancesResult / bNumFact);
			setResultTxt = `You have a <strong>1 in ${setResult}</strong> chance of winning in this set of numbers.`;

			////////////////////////////////////////

		
			mathCalcSteps +=`
				<tr>
					<td class="oddsCalc-calcSteps-desc">
						Since the order of your numbers does not matter, your chances are higher. So we divide this by the ${draw.winning}! (${factorialDescribe })
					</td>
					<td class="oddsCalc-calcSteps-calc">
						( ${chanceStr} ) / ${draw.winning}! = 1/${chancesResult / bNumFact}
					</td>
				</tr>
				<tr class="oddsCalc-calcSteps-set"><td colspan="2" >${setResultTxt}</td></tr>
				`;

				drawsResults.push(setResult);
				chancesAllDraws *= setResult;

		});


		for (var i = 0; i < drawsResults.length; i++) {
			allSetsChansesStr += `(1/${drawsResults[i]})*`;
		}
		allSetsChansesStr = allSetsChansesStr.slice(0, -1);


		finalResult = chancesAllDraws/ticketsN;


		mathCalcSteps += `<tr>
			<td class="oddsCalc-calcSteps-desc">
				Now lets get chances for all sets of numbers
			</td>
			<td class="oddsCalc-calcSteps-calc">
				${allSetsChansesStr} = 1/${chancesAllDraws}
			</td>
		</tr>
		${ticketsN > 1 ? 
				`<tr>
					<td class="oddsCalc-calcSteps-desc">
						Since you bought ${ticketsN} tickets, your odds go from 1 in ${chancesAllDraws.toLocaleString()} to ${ticketsN} in ${chancesAllDraws.toLocaleString()}.
					</td>
					<td class="oddsCalc-calcSteps-calc">
						(1/${chancesAllDraws}) * ${ticketsN} = 1 / ${finalResult}
					</td>
				</tr>`
		:''}`;

		mathCalcSteps += `<tr class="oddsCalc-calcSteps-final"><td colspan="2" >You have a <strong>1 in ${Math.ceil(finalResult).toLocaleString()}</strong> chance of winning lottery.</td></tr>`;
		mathCalcSteps += '</table>';

		resultsNode.innerHTML = mathCalcSteps;

		finalChancesNode.innerHTML = `Since you bought <strong>${ticketsN} tickets</strong>,
		<br>You have a <strong>1 in ${Math.ceil(finalResult).toLocaleString()}</strong> chance of winning lottery<br>
		 ${ getOddsExample( finalResult ) } 
		`;

	}

	function getOddsExample( value ) {

	    let lastDelta = Number.MAX_SAFE_INTEGER,
	    delta = 0,
	    resultExample = {},
	    resultText = '',
	    moreLikelyTimes = 0;


	    CHANCES_EXAMPLES.forEach((example)=>{
	    	delta = value - example.odds;



	    	if( (delta <= lastDelta) && (delta >=0) ) {
	    	
	    		resultExample = example;
	    		lastDelta = delta;
	    	}

	    });

	    moreLikelyTimes = Math.round(value / resultExample.odds);


	    if(moreLikelyTimes > 1) {
	    	resultText = `<span class="oddsCalc-oddsExample">${resultExample.timesText.replace('{n}',moreLikelyTimes)}</span>`;
	    }else {
	    	resultText = `<span class="oddsCalc-oddsExample">${resultExample.sameText}</span>`;
	    }

	    return resultText;
	}

	function ordinal_suffix(i) {
			let j = i % 10,
					k = i % 100;
			if (j == 1 && k != 11) {
					return i + "st";
			}
			if (j == 2 && k != 12) {
					return i + "nd";
			}
			if (j == 3 && k != 13) {
					return i + "rd";
			}
			return i + "th";
	}

	function factorial(n) {
		return n ? n * factorial(n - 1) : 1;
	}

	calcChances();

}




// WEBPACK FOOTER //
// ./js/src/oddsCalc.js